var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Artboard_3"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 24
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artboard_3",
    "data-name": "Artboard \\u2013 3",
    clipPath: "url(#clip-Artboard_3)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons_16px_white_mobile-button_",
    "data-name": "Icons/16px/white/mobile-button ",
    transform: "translate(6.513 6.239)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "mobile-button"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle-path",
    d: "M.725,0H7.249a.747.747,0,0,1,.725.768v9.986a.747.747,0,0,1-.725.768H.725A.747.747,0,0,1,0,10.755V.768A.747.747,0,0,1,.725,0Z",
    fill: "none",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 0.725,
    cy: 0.768,
    rx: 0.725,
    ry: 0.768,
    transform: "translate(3.262 8.066)",
    stroke: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobile);
export default __webpack_public_path__ + "static/media/mobile.da006b7b626cbbc1a352904644d42ea9.svg";
export { ForwardRef as ReactComponent };